function FuncionarioCertificados() {
    return (
        <div className="rounded-[var(--radius-md)] bg-surface p-[22px] shadow-[0_8px_20px_rgba(0,0,0,0.05)]">
            <h3 className="mb-5 text-lg font-semibold text-primary">Últimos Certificados Emitidos</h3>

            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th>Folio</th>
                            <th>Titular</th>
                            <th>Fecha</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[
                            { folio: "CER-0001", titular: "Juan Pérez",   fecha: "29/07/2026" },
                            { folio: "CER-0002", titular: "María López",  fecha: "29/07/2026" },
                            { folio: "CER-0003", titular: "Carlos Ruiz",  fecha: "28/07/2026" },
                        ].map((row) => (
                            <tr key={row.folio}>
                                <td>{row.folio}</td>
                                <td>{row.titular}</td>
                                <td>{row.fecha}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default FuncionarioCertificados;
